import { EventBus } from 'quasar'
import { boot } from 'quasar/wrappers'

/**
 * @param {import('@quasar/app-webpack').BootFileParams} params
 */
export default boot(({ app }) => {
  const bus = new EventBus()

  // for Options API
  app.config.globalProperties.$emit = bus.emit
})
